export const hasScoreAlert = (
  submission,
  scoreAlertAThreshold,
  scoreAlertBThresholdHi,
  scoreAlertBThresholdLo
) => {
  const points = submission.evaluations.map((score) => score.totalPoints);
  const max = Math.max(...points);
  const min = Math.min(...points);
  if (
    max - min > scoreAlertAThreshold ||
    (max >= scoreAlertBThresholdLo && min <= scoreAlertBThresholdHi)
  ) {
    return true;
  }
  return false;
};

export function hasScoreAlertFlag(submission) {
  return (
    submission?.scoreAlertA ||
    submission?.scoreAlertB ||
    submission?.scoreAlertC
  );
}
